import request from '@/utils/request'

/**
 * 取得 AI Agent 列表
 * @param {Object} query - 查詢參數
 * @param {string} query.search - 搜尋文字
 * @param {boolean} query.status - 狀態過濾
 * @param {number} query.page - 頁碼
 * @param {number} query.limit - 每頁筆數
 * @param {string} query.sort - 排序
 */
export function getAiAgentList(query) {
  return request({
    url: '/AiAgent',
    method: 'get',
    params: query,
  })
}

/**
 * 取得單筆 AI Agent
 * @param {number} id - AI Agent ID
 */
export function getAiAgent(id) {
  return request({
    url: `/AiAgent/${id}`,
    method: 'get',
  })
}

/**
 * 儲存 AI Agent (新增/更新)
 * @param {Object} data - AI Agent 資料
 * @param {number} data.id - ID (更新時必填)
 * @param {string} data.siteName - 場域名稱
 * @param {string} data.apiKey - API Key
 * @param {boolean} data.isEnabled - 是否啟用
 */
export function saveAiAgent(data) {
  return request({
    url: '/AiAgent/save',
    method: 'post',
    data,
  })
}

/**
 * 刪除 AI Agent
 * @param {number} id - AI Agent ID
 */
export function deleteAiAgent(id) {
  return request({
    url: `/AiAgent/${id}`,
    method: 'delete',
  })
}

/**
 * 批次刪除 AI Agent
 * @param {number[]} ids - AI Agent ID 列表
 */
export function batchDeleteAiAgent(ids) {
  return request({
    url: '/AiAgent/batch',
    method: 'delete',
    data: ids,
  })
}

/**
 * 更新 AI Agent 狀態
 * @param {number} id - AI Agent ID
 * @param {boolean} enabled - 啟用狀態
 */
export function updateAiAgentStatus(id, enabled) {
  return request({
    url: `/AiAgent/${id}/status`,
    method: 'patch',
    data: enabled,
  })
}
